<style scoped>
    .mis-table {
        max-width: 600px;
    }
    .handler {
        padding-left: 20px;
    }
</style>
<template>
  <div>
    <table
      v-if="last_record.id"
      class="mis-table"
    >
      <tr>
        <th>最新数据</th>
        <th>美元</th>
        <th>欧元</th>
        <th>日元</th>
        <th>港元</th>
        <th>英镑</th>
      </tr>
      <tr>
        <td>{{ last_record.exchange_date }}</td>
        <td>{{ $util.formatPrice(last_record.usd) }}</td>
        <td>{{ $util.formatPrice(last_record.eur) }}</td>
        <td>{{ $util.formatPrice(last_record.jpy) }}</td>
        <td>{{ $util.formatPrice(last_record.hkd) }}</td>
        <td>{{ $util.formatPrice(last_record.gbp) }}</td>
      </tr>
    </table>
    <Divider v-if="last_record.id" />
    <div
      v-if="records.length"
      class="line handler"
    >
      <Checkbox v-model="show_average">
        显示平均值
      </Checkbox>
      <Checkbox v-model="show_max">
        显示最大值
      </Checkbox>
      <Checkbox v-model="show_min">
        显示最小值
      </Checkbox>
      <Button
        size="small"
        icon="md-download"
        @click="exportData"
      >
        导出数据
      </Button>
    </div>
    <VeLine
      class="chart"
      :legend="legend"
      :series="series"
      :x-axis="x_axis"
      :y-axis="y_axis"
      :mark-line="mark_line"
      :data-zoom="data_zoom"
      :grid="{right: 80}"
      :not-set-unchange="['dataZoom', 'markLine']"
      resizeable
      :loading="loading"
    />
    <div class="line color-error">
      备注: 货币汇率中间价采取直接标价法，即100外币折合多少人民币。
    </div>
  </div>
</template>
<script route="/fin/rmb_central_parities">
  import VeLine from 'v-charts/lib/line.common';

  export default {
    /* router_info_start */
    router_info: '/fin/rmb_central_parities',
    /* router_info_end */

    components: {VeLine},
    data() {
      return {
        records: [],
        loading: false,
        show_average: false,
        show_max: false,
        show_min: false,
      }
    },
    computed: {
      cur_customer() {
        return this.$store.state.cur_customer;
      },
      last_record() {
        const len = this.records.length;
        return len ? this.records[len - 1] : {};
      },
      data_zoom() {
        const len = this.records.length;
        const start = len > 30 ? (len - 30) / len * 100 : 90;
        return [{type: 'slider', start: start, end: 100}]
      },
      x_axis() {
        const axis = {type: 'category', data: []};
        this.records.forEach((record) => {
          axis.data.push(record.exchange_date);
        });
        return axis;
      },
      y_axis() {
        return {
          min: (value) => {
            return parseInt(value.min - 5);
          }
        }
      },
      series() {
        const series = {
          usd: {type: 'line', name: '美元', data: []},
          gbp: {type: 'line', name: '英镑', data: []},
          eur: {type: 'line', name: '欧元', data: []},
          hkd: {type: 'line', name: '港元', data: []},
          jpy: {type: 'line', name: '日元', data: []},
        };
        this.records.forEach((record) => {
          Object.keys(series).forEach((key) => {
            series[key].data.push([record.exchange_date, parseFloat(record[key])]);
          });
        });
        return Object.values(series);
      },
      legend() {
        const legend = {data: [], left: 15, symbolKeepAspect: true};
        this.series.forEach((serie) => {
          legend.data.push({
            name: serie.name,
            icon: 'circle'
          });
        });
        return legend;
      },
      mark_line() {
        const json = { data: [] };
        if (this.show_average) {
          json.data.push({name: '平均值', type: 'average'});
        }
        if (this.show_max) {
          json.data.push({name: '最大值', type: 'max'});
        }
        if (this.show_min) {
          json.data.push({name: '最小值', type: 'min'});
        }
        return json;
      },
      chart_data() {
        return this.records;
      }
    },
    created() {
      this.getRecords();
    },
    mounted() {
      //
    },
    methods: {
      getRecords() {
        this.loading = true;
        this.$util.ajax.get(this.$util.api.rmb_central_parities, {
          params: {}
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            this.records = res.data.records;
          } else {
            this.$Modal.warning({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          this.$Modal.warning({title: '错误', content: e.message});
        }).finally(() => {
          this.loading = false;
        });
      },
      exportData() {
        window.open(this.$util.api.export_rmb_central_parities, '_blank');
      }
    }
  }
</script>
